import { Controller, useFieldArray } from 'react-hook-form'
import { Input, Select, Spinner, Textarea, Toggle } from '@/components/ui'
import MultipleFileInput from '@/components/ui/Input/MultipleFileInput'

import { InterventionStatuses, MaterielStatuses, FacturationStatuses } from '../interventionsSlice'
import { useInterventionForm } from './InterventionFormContext'
import SuggestionBienField from '../../biens/SuggestionField'
import SuggestionField from "../../prestataires/SuggestionField"

export default () => {
  const { bien, control, intervention, entiteFacturableOptions, 
    isFetchingBien,
    isBienFromContext,
    handleNewPrestataire, hasError, getErrorMessage 
  } = useInterventionForm()

  const bienCodageInterne = bien?.codage_interne || intervention?.bien?.codage_interne || ""

  const fieldArray = useFieldArray({
    control,
    name: "photos"
  })

  return (
    <div className="grid grid-cols-3 gap-2 p-4">
      <div className='flex flex-col pl-2 space-y-4'>
        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Info intervention :</h3>
          { !isBienFromContext && !intervention?.bien_id  ? (<Controller 
              name='bien'
              control={control}
              defaultValues={""}
              rules={{
                required: "Le bien doit être défini."
              }}
              render={({field}) => (
                <SuggestionBienField
                  objectField={field}
                  originalData={intervention.bien}
                  validator={{hasError, getErrorMessage}}
                />
              )}
            />) : (
              isFetchingBien ? <Input.Display label="Bien">
                <Spinner size="sm"/>
              </Input.Display> :
              <Input.Display label="Bien" value={bienCodageInterne} />
            )
          }

          <Controller 
            name='prestataire'
            control={control}
            defaultValue={""}
            className=''
            render={({field}) => (
              <SuggestionField
                prestataireField={field}
                originalData={intervention.prestataire}
                label='Prestataire'
                onNewPrestataire={handleNewPrestataire}
                validator={{hasError, getErrorMessage}}
              />
            )}
          />

          <Textarea.Form name='details'
            label="Détails de l'intervention"
            control={control}
            validator={{hasError, getErrorMessage}}
          />

          <Textarea.Form name='materiel_a_fournir'
            label="Matériel à fournir par le client"
            control={control}
          />

          <Input.Date
            name='date_intervention'
            label="Date de l'intervention"
            control={control}
            className="w-full"
          />
        </div>

        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Info devis :</h3>
          <Input.Text
            name='info_rdv'
            label='Info rdv'
            control={control}
          />

          <Input.File
            name='devis'
            label='Devis'
            control={control}
            defaultValue={intervention.devis?.filename || '' }
            inputProps={{accept: ".pdf"}}
            validator={{hasError, getErrorMessage}}
            canDelete={true}
          />

        </div>
      </div>

      <div className='flex flex-col pl-2 space-y-4'>
        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Info facture :</h3>
          <Input.Currency
            name='montant'
            label='Montant chantier'
            control={control}
          />

          <Input.Currency
            name='montant_materiel'
            label='Montant matériel'
            control={control}
          />

          { isFetchingBien ? (<Input.Display label='Entité à facturer'>
              <Spinner size='sm' />
            </Input.Display>) :
            <Select.Form
              name='entite_facturable'
              control={control}
              label='Entité à facturer'
              options={entiteFacturableOptions}
              validator={{hasError, getErrorMessage}}
              className='w-full'
            />
          }
          <Input.File
            name='facture_materiel'
            label='Facture matériel'
            control={control}
            defaultValue={intervention.facture_materiel?.filename || '' }
            inputProps={{accept: ".pdf"}}
            validator={{hasError, getErrorMessage}}
            canDelete={true}
          />

          <Input.File
            name='facture_acompte'
            label='Facture acompte'
            control={control}
            defaultValue={intervention.facture_acompte?.filename || '' }
            inputProps={{accept: ".pdf"}}
            validator={{hasError, getErrorMessage}}
            canDelete={true}
          />
          <Input.File
            name='facture_cloture'
            label='Facture clôture'
            control={control}
            defaultValue={intervention.facture_cloture?.filename || '' }
            inputProps={{accept: ".pdf"}}
            validator={{hasError, getErrorMessage}}
            canDelete={true}
          />

        </div>

      </div>

      <div className='flex flex-col space-y-4'>

        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Affichage :</h3>
          <Toggle.Form
            control={control}
            name="display_to_proprietaire"
            label="Propriétaire"
          />
          <Toggle.Form
            control={control}
            name="display_to_locataire"
            label="Locataire"
          />
          <Toggle.Form
            control={control}
            name="display_to_acquereur"
            label="Acquéreur"
          />
        </div>

        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Notifications :</h3>
          <Toggle.Form
            control={control}
            name="do_not_notify"
            label="Ne pas notifier"
          />
        </div>

        <div className="flex flex-col space-y-4">
          <h3 className='font-bold'>Statuts :</h3>
          <Select.Form
            name='statut'
            control={control}
            label="Statut de l'intervention"
            options={InterventionStatuses}
            className='w-full'
          />
          <Select.Form
            name='statut_materiel'
            control={control}
            label="Statut du matériel"
            options={MaterielStatuses}
            className='w-full'
          />
          <Select.Form
            name='statut_facturation'
            control={control}
            label="Statut de la facturation"
            options={FacturationStatuses}
            className='w-full'
          />
        </div>

        <div className='flex flex-col space-y-4'>
          <h3 className='font-bold'>Fin d'intervention :</h3>
          <Input.File
            name='pv_livraison'
            label='PV de livraison'
            control={control}
            defaultValue={intervention.pv_livraison?.filename || '' }
            inputProps={{accept: ".pdf"}}
            validator={{hasError, getErrorMessage}}
            canDelete={true}
          />

          <div>
            <MultipleFileInput
              label="photos"
              individualLabel="Photo"
              fieldArrayProps={fieldArray}
              inputProps={{accept: "image/*"}}
              validator={{hasError, getErrorMessage}}
              displayHelperText={false}
            />
          </div>
        </div>

      </div>
    </div>
  )
}